import React from 'react';
import { IconSparkles } from '@tabler/icons-react';
import styles from './NBACard.module.css';

interface NBACardProps {
  title: string;
  description: string;
  onClick: () => void;
}

const NBACard: React.FC<NBACardProps> = ({
  title,
  description,
  onClick,
}) => {
  return (
    <button 
      className={styles.nbaCard} 
      onClick={onClick}
      type="button"
      aria-label={`${title}: ${description}`}
    >
      {/* Icon container */}
      <div className={styles.iconContainer}>
        <IconSparkles size={14.4} color="#4C189A" />
      </div>
      
      {/* Content container */}
      <div className={styles.contentContainer}>
        {/* Title */}
        <h3 className={styles.title}>{title}</h3>
        
        {/* Description */}
        <p className={styles.description}>{description}</p>
      </div>
    </button>
  );
};

export default NBACard;
